<ng-template [ngIf]="isToggleProductUrlActive">
  <div class="card">
    <a href="{{productUrl}}" target="{{target}}" (click)="sendAnalyticsEvent($event);$event.stopPropagation()">
      <ng-container *ngTemplateOutlet="linkContent"></ng-container>
    </a>
  </div>
</ng-template>
<ng-template [ngIf]="!isToggleProductUrlActive">
  <div tabindex="0" class="card" (click)="goToProduct(productCard.sku)">
    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
  </div>
</ng-template>
<ng-template #linkContent>
  <ng-content></ng-content>
</ng-template>
